interface IUserLike {
	nickname?:  string | null
	firstName?: string | null
	lastName?:  string | null
	username?:  string | null
}

export function getUserDisplayName(user: IUserLike | undefined | null, fallback = 'Игрок'): string {
	if (!user) {
		return fallback
	}

	if (user.nickname) {
		return user.nickname
	}

	if (user.firstName) {
		return user.firstName
	}

	if (user.username) {
		return user.username
	}

	return fallback
}

export function getUserFullDisplayName(user: IUserLike | undefined | null, fallback = 'Игрок'): string {
	if (!user) {
		return fallback
	}

	if (user.nickname) {
		return user.nickname
	}

	const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()

	if (fullName) {
		return fullName
	}

	if (user.username) {
		return user.username
	}

	return fallback
}
